import { type FC } from 'react'

import style from './_stacked-avatar.module.scss'

type Props = {
  /** Only pass real avatar URLs here (exclude users with no avatar). */
  avatars: string[]
  /** Max number of avatar bubbles to show before collapsing into +N (kept as your original misspelling for compatibility). */
  avtarsCount?: number
  /** Extra class for the wrapper */
  customClass?: string
  /** TOTAL number of users (with and without avatars). If omitted, falls back to avatars.length */
  count?: number
  userText?:boolean
  avatarSize?: 'default' | 'small'
}

/**
 * Renders up to `avtarsCount` avatar images (only those with URLs),
 * and shows a "+N" bubble where N = total count - actually visible images.
 * This ensures users without avatars contribute to the "+N" count without
 * showing a placeholder image.
 */
const StackedAvatar: FC<Props> = ({
  avatars,
  avtarsCount = 4,
  customClass = '',
  count,
  userText = false,
  avatarSize = 'default'
}) => {
  // true total (with & without avatars)
  const totalCount = typeof count === 'number' ? count : avatars.length
  const sizeClass = avatarSize === 'small' ? style.small : ''
  // how many avatar images we can actually render
  const visibleCount = Math.min(avtarsCount, avatars.length)

  // only render as many as we can show
  const visibleAvatars = avatars.slice(0, visibleCount)

  // overflow must be based on TOTAL count, not avatars.length or avtarsCount
  const overflow = Math.max(0, totalCount - visibleCount)

  return (
    <div className={`${style.avatar_container} ${customClass}`}>
{visibleAvatars.map((avatar, index) => (
    <div
        key={index}
        className={`${style.avatar_circle} ${sizeClass}`}
        style={{ left: `${index * 1.7}rem` }}
    >
        <img src={avatar} alt='avatar' />
    </div>
))}

{overflow > 0 && (
    <div
        className={`${style.remaining_avatars} ${sizeClass}`}
        style={{ left: `${visibleAvatars.length * 1.7}rem` }}
    >
        {overflow}
    </div>
)}
    </div>
  )
}

export default StackedAvatar
